// @vendor
const Immutable = require('immutable');

// @helpers
const { formatText } = require('core/i18n').i18n;

const getDummyData = () => Immutable.fromJS([{
	id: 111,
	name: formatText('brokerWatchList-emptyStateFirstListName'),
	products: [{
		isin: "ES1118594417",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateFirstProductName'),
		dgsCode: "DGS code",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES1113211835",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateSecondProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES1113307062",
		micCode: "XPAR",
		name: formatText('brokerWatchList-emptyStateThirdProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}],
	productsCount: 3
}, {
	id: 222,
	name: formatText('brokerWatchList-emptyStateSecondListName'),
	products: [{
		isin: "ES2118594417",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateFirstProductName'),
		dgsCode: "DGS code",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES2113211835",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateSecondProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES1113307062",
		micCode: "XPAR",
		name: formatText('brokerWatchList-emptyStateThirdProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}],
	productsCount: 2
}, {
	id: 333,
	name: formatText('brokerWatchList-emptyStateThirdListName'),
	products: [{
		isin: "ES2118594417",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateFirstProductName'),
		dgsCode: "DGS code",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES2113211835",
		micCode: "XMCE",
		name: formatText('brokerWatchList-emptyStateSecondProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}, {
		isin: "ES1113307062",
		micCode: "XPAR",
		name: formatText('brokerWatchList-emptyStateThirdProductName'),
		ticker: "ticker",
		quote: 0.00,
		currency: "EUR",
		variation: 0.00,
		marketable: true
	}],
	productsCount: 0
}]);

module.exports = {
	getDummyData,
	MAX_PRODUCT_COUNT: 25,
	BROKER_ADVANCED_SEARCH_WATCHLIST_URL: '/myprofile/broker/exploreWatchlist/',
	LIST_NAME_MAX_LENGTH: 30,
	MAX_LIST_COUNT: 10,
	TYPE_STOCK: 'stock',
	TYPE_PLAN: 'pension plan',
	TYPE_FUND: 'investment fund',
	TYPE_ETF: 'etf',
	TYPE_WARRANT: 'warrant',
	INITIAL_WATCHLIST_EDIT_ID: -1 //No list is in the EDIT mode
};